import { IosArrowDown, IosArrowUp } from '@sgcmpteltd/uikit-react';
import { useState } from 'react';

import styles from './styles.module.scss';
import type { Component } from './types';

export const Accordion: Component = ({
  title,
  children,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <>
      <button
        className={styles.btnAccordion}
        onClick={handleClick}>
        <span className={styles.textTitle}>
          {title}
        </span>
        {isOpen
          ? (
            <IosArrowUp
              className={styles.iconArrow}
              size={14} />
          )
          : (
            <IosArrowDown
              className={styles.iconArrow}
              size={14} />
          )}
      </button>
      {isOpen && children}
    </>
  );
};
